import mm from "moment";

export function getTimeStamp(time, format = "YYYY-MM-DDTHHmmss") {
  if (time) {
    return mm(time).format(format);
  }
  return mm().format(format);
}

export function dateFormat(t, k = "YYYY-MM-DD") {
  if (!t) return "";
  return mm(t).format(k).toString();
}